<template>
  <div
    class="offline-search button"
    :class="{'offline-search--active': useOfflineSearch }"
    @click="setOfflineSearch()"
  >
    <div class="offline-search__icon">
      <icon name="search" />
    </div>
    <div
      class="button__label"
      v-if="useOfflineSearch == true"
    >{{resource('offlineSearchOn')}}</div>
    <div
      class="button__label"
      v-if="useOfflineSearch == false"
    >{{resource('offlineSearchOff')}}</div>
  </div>
</template>

<style lang="scss">
.offline-search {
  &__icon {
    display: flex;
    width: 35px;
    height: 35px;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    color: #fff;
    background: $ok;
  }
  .button__label {
    margin-left: $component;
  }
  &--active .offline-search__icon {
    background: $error;
  }
}
</style>

<script>
export default {
	name: 'offlineSearch',
	methods: {
		resource (item) {
			var lang = this.$store.getters.language
			return this.res[lang][item]
		},
		setOfflineSearch (value) {
			if (value === undefined) {
				this.$store.commit('toggleOfflineSearchUsage', !this.useOfflineSearch)
			} else {
				this.$store.commit('toggleOfflineSearchUsage', value)
			}

		}
	},
	created () {
		if (window.localStorage.offlineSearch === 'true') {
			this.setOfflineSearch(true)
		} else {
			this.setOfflineSearch(false)
		}
	},
	computed: {
		useOfflineSearch () {
			return this.$store.getters.offlineSearch
		}
	},
	data () {
		return {
			res: {
				nl: {
					offlineSearchOn: 'Offline zoeken',
					offlineSearchOff: 'Online zoeken'
				},
				fr: {
					offlineSearchOn: 'Recherche hors ligne',
					offlineSearchOff: 'Rechercher en ligne'
				}
			}
		}
	}
}
</script>
